import { FormBase } from 'core/components';

export default class ProductEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'firstName',
                    label: 'PERSON.EDIT.FIRST_NAME_LABEL',
                    placeholder: 'PERSON.EDIT.FIRST_NAME_PLACEHOLDER',
                    rules: 'string|required'
                },
                {
                    name: 'lastName',
                    label: 'PERSON.EDIT.LAST_NAME_LABEL',
                    placeholder: 'PERSON.EDIT.LAST_NAME_PLACEHOLDER',                 
                    rules: 'string|required'
                },
                {
                    name: 'userId',
                    label: 'PERSON.EDIT.USER_LABEL',
                    placeholder: 'PERSON.EDIT.USER_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'email',
                    label: 'PERSON.EDIT.EMAIL_LABEL',
                    placeholder: 'PERSON.EDIT.EMAIL_PLACEHOLDER',
                    rules: 'email|string'
                },
                {
                    name: 'position',
                    label: 'PERSON.EDIT.POSITION_LABEL',
                    placeholder: 'PERSON.EDIT.POSITION_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'phone',
                    label: 'PERSON.EDIT.PHONE_LABEL',
                    placeholder: 'PERSON.EDIT.PHONE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'initials',
                    label: 'PERSON.EDIT.INITIALS_LABEL',
                    placeholder: 'PERSON.EDIT.INITIALS_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'extension',
                    label: 'PERSON.EDIT.EXTENSION_LABEL',
                    placeholder: 'PERSON.EDIT.EXTENSION_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'isActive',
                    type: 'bool',
                    value: false
                },
            ],
        };
    }
}
